import api from '@/services/api'

export const getQuizList = async (page = 1, size = 5) => {
    try {
        const response = await api.get(`quiz?item_per_page=${size}&page=${page}`)
        return response.data.data
    } catch (e) {
        console.error(e)
        throw e
    }
}

export const getAllQuizes = async () => {
    try {
        const response = await api.get(`quiz/listsimple`)
        return response.data.data
    } catch (e) {
        console.error(e)
        throw e
    }
}

export const updateQuiz = async (id, data) => {
    try {
        const response = await api.put(`quiz/${id}`, data)
        return response.data
    } catch (e) {
        console.error(e)
        throw e
    }
}

export const deleteQuiz = async (id) => {
    try {
        const response = await api.delete(`quiz/${id}`)
        return response.data.data
    } catch (e) {
        console.error(e)
        throw e
    }
}

export const createQuiz = async (data) => {
    try {
        const response = await api.post(`quiz`, data)
        return response.data.data
    } catch (e) {
        console.error(e)
        throw e
    }
}

export const getAnswersList = async (id, page, startDate, finalDate, sections, size = 3) => {
    try {
        let url = `quiz/answerlist?id=${id}&page=${page}&item_per_page=${size}`

        if (startDate) url += `&start_date=${startDate}`

        if (finalDate) url += `&end_date=${finalDate}`

        if (sections.length) url += `&sections=${sections}`

        const response = await api.get(url)
        return response.data.data
    } catch (e) {
        console.error(e)
        throw e
    }
}

export const getReportList = async (id, endDate) => {
    try {
        let url = `quiz/report?quiz_id=${id}&end_date=${endDate}`

        const response = await api.get(url)
        return response.data.data
    } catch (e) {
        console.error(e)
        throw e
    }
}

export const exportReport = async (id, startDate, finalDate) => {
    try {
        let url = `quiz/report/email?quiz_quiz_id=${id}&start_date=${startDate}&end_date=${finalDate}`

        const response = await api.get(url)
        return response.data.data
    } catch (e) {
        console.error(e)
        throw e
    }
}
